export default __webpack_public_path__ + "static/media/spinachsupercocktail-wide@3x.5e66ebbf.jpg";